<template>
  <div class="about">
    <h1>New Audit</h1>
    <b-form @submit="on_submit" @reset="on_reset">
        <b-form-group horizontal label="General information" label-size="lg" class="mb-0" label-class="font-weight-bold pt-0">
            <b-form-group horizontal label-class="text-sm-right" id="orderInputGroup" label="Order Number" label-for="inputOrderNumber" description="">
                <b-form-input id="inputOrderNumber" type="text" v-model="form.order_no" required placeholder="DE-00-12345">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="dateInputGroup" label="Date" label-for="dateInput" description="">
                <b-form-input id="dateInput" type="date" v-model="form.date" required>
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="reasonInputGroup" label="Reason" label-for="reasonInput" description="">
                <b-form-input id="reasonInput" type="text" v-model="form.reason" required>
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-auditor" label="Auditor" label-for="input-auditor" description="">
                <b-form-input id="input-auditor" type="text" v-model="form.auditor">
                </b-form-input>
            </b-form-group>
        </b-form-group>
        <hr />

        <b-form-group horizontal label="Supplier information" label-size="lg" class="mb-0" label-class="font-weight-bold pt-0">
            <b-form-group horizontal label-class="text-sm-right" id="input-group-request" label="Requested by" label-for="input-request" description="">
                <b-form-input id="input-request" type="text" v-model="form.request">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-supplier_number" label="Supplier Number" label-for="input-supplier_number" description="">
                <b-form-input id="input-supplier_number" type="text" v-model="form.supplier_number">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-duns_number" label="DUNS Number" label-for="input-duns_number" description="">
                <b-form-input id="input-duns_number" type="text" v-model="form.duns_number">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-supplier" label="Supplier" label-for="input-supplier" description="">
                <b-form-input id="input-supplier" type="text" v-model="form.supplier">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-street" label="Street" label-for="input-street" description="">
                <b-form-input id="input-street" type="text" v-model="form.street">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-post_code" label="Post Code" label-for="input-post_code" description="">
                <b-form-input id="input-post_code" type="text" v-model="form.post_code">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-country" label="Country" label-for="input-country" description="">
                <b-form-input id="input-country" type="text" v-model="form.country">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-telephone_number" label="Telephone Number" label-for="input-telephone_number" description="">
                <b-form-input id="input-telephone_number" type="text" v-model="form.telephone_number">
                </b-form-input>
            </b-form-group>

            <b-form-group horizontal label-class="text-sm-right" id="input-group-signed_by" label="Signed by" label-for="input-signed_by" description="">
                <b-form-input id="input-signed_by" type="text" v-model="form.signed_by">
                </b-form-input>
            </b-form-group>
        </b-form-group>


        <b-button type="submit" variant="primary">Submit</b-button>

        <b-button type="reset" variant="danger">Reset</b-button>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data () {
    return {
      form: {
        order_no: '',
        date: '',
        reason: '',
        request: '',
        auditor: '',
        supplier_number: '',
        duns_number: '',
        supplier: '',
        street: '',
        country: '',
        post_code: '',
        telephone_number: '',
        fax_number: '',
        signed_by: '',
        last_audit_cert_number: '',
        last_audit_issue_date: ''
      },
      show: true
    }
  },
  methods: {
    on_submit (evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
      this.$http.post('v1/audits', this.form).then(response => {
          console.log(response)
          if (response.status == 200) {
              this.$router.push('/audit/' + response.data.response.audit_id);
          }
      })
    },
    on_reset (evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.order_no = '';
      this.form.name = '';
      this.form.date = null;
      this.form.reason = '';
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => { this.show = true });
    }
  }
}
</script>
